import { render } from "./UnitDetailsHeader.vue?vue&type=template&id=64e50ff0"
import script from "./UnitDetailsHeader.vue?vue&type=script&lang=js"
export * from "./UnitDetailsHeader.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__